/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_AcceptInputs */

const en_us2_coaching_accept = /** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const pt_br2_coaching_accept = /** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar`)
};

const pt_pt2_coaching_accept = /** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar`)
};

/** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */
const es_419_coaching_accept = en_us2_coaching_accept;

/** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */
const fr_fr2_coaching_accept = en_us2_coaching_accept;

/** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */
const de_de2_coaching_accept = en_us2_coaching_accept;

/** @type {(inputs: Coaching_AcceptInputs) => LocalizedString} */
const it_it2_coaching_accept = en_us2_coaching_accept;

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Coaching_AcceptInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_accept = /** @type {((inputs?: Coaching_AcceptInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_AcceptInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_accept(inputs)
	if (locale === "es-419") return es_419_coaching_accept(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_accept(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_accept(inputs)
	if (locale === "de-DE") return de_de2_coaching_accept(inputs)
	if (locale === "it-IT") return it_it2_coaching_accept(inputs)
	return en_us2_coaching_accept(inputs)
});
export { coaching_accept as "coaching.accept" }